import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { LabelSelectorModule } from '@core/components/label-selector/label-selector.module';
import { FuseMaterialColorPickerModule } from '@fuse/components/material-color-picker/material-color-picker.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogEditMaintenanceComponent } from './dialog-maintenances.component';
import { DialogMaintenancesService } from './dialog-maintenances.service';
import { TabAttachmentsModule } from './tabs/attachments/tab-attachments.module';
import { TabCommentsModule } from './tabs/comments/tab-comments.module';
import { TabDeadlineModule } from './tabs/deadline/tab-deadline.module';
import { TabFormsModule } from './tabs/forms/tab-forms.module';
import { TabLinksModule } from './tabs/links/tab-links.module';
import { TabLogsModule } from './tabs/logs/tab-logs.module';
import { TabMaintenanceModule } from './tabs/maintenance/tab-maintenance.module';
import { TabNewDeadlineModule } from './tabs/new-deadline/tab-new-deadline.module';
import { PendenciesModule } from './tabs/pendencies/pendencies.module';
import { TabProductsModule } from './tabs/products/tab-products.module';
import { TabQuotationsModule } from './tabs/quotations/tab-quotations.module';
import { TabServicesModule } from './tabs/services/tab-services.module';
import { TabTasksModule } from './tabs/tasks/tab-tasks.module';

@NgModule({
  entryComponents: [
    DialogEditMaintenanceComponent
  ],
  declarations: [
    DialogEditMaintenanceComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    FuseMaterialColorPickerModule,

    MatIconModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatTooltipModule,

    TabMaintenanceModule,
    TabNewDeadlineModule,
    TabCommentsModule,
    TabAttachmentsModule,
    TabLogsModule,
    TabLinksModule,
    TabDeadlineModule,
    TabTasksModule,
    TabQuotationsModule,
    DisclaimerModule,
    LabelSelectorModule,
    TabFormsModule,
    TabProductsModule,
    TabServicesModule,
    PendenciesModule
  ],
  providers: [
    DialogMaintenancesService,
  ],
  exports: [
    DialogEditMaintenanceComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class DialogEditMaintenanceModule { }
